module.exports = __webpack_public_path__ + "media/images/step2-e813966217ad8bdb932fa2eb193d5e02.png";